import { UserSettings } from "@simplimods/types";

export const InitialSettingsConfig: UserSettings = {
  accountType: "user",
  hasPin: false,
  accountVerified: false,
  isBusiness: false,
  canCreateEvents: false,
  defaultToMobileLinkView: false,
};
